/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import SectionContainer from '../SectionContainer';

export const SectionContainerStyled = styled(SectionContainer)`
  ${({ theme, cardType }) => {
    const mobile = theme.useMediaQuery(theme.breakpoints.down('medium'));
    return css`
      padding-left: ${cardType === 'default' && mobile ? rem(28) : 0};
      padding-right: ${cardType === 'default' && mobile ? rem(28) : 0};
    `;
  }}
`;
